var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { themeLss } from "../../lss";
import styled from "../../styled";
import { Checkbox } from '../Checkbox';
export var Table = styled.table(themeLss({
    width: '100%',
    tableLayout: 'fixed'
}));
export var TableHeader = styled.thead(themeLss({
    width: '100%',
    fontWeight: 'bold'
}));
export var TableHeaderRow = styled.tr(themeLss({
    borderBottom: 'thick'
}));
export var TableBody = styled.tbody(themeLss({ width: '100%' }));
export var TableBodyRow = styled.tr(themeLss({
    borderBottom: 'regular',
    ':hover': {
        bg: 'opacityLight'
    }
}));
export var TableFooter = styled.tfoot(themeLss({
    width: '100%',
    fontWeight: 'bold'
}));
export var TableFooterRow = styled.tr(function (_a) {
    var footerRowLss = _a.footerRowLss;
    return themeLss(__assign({}, footerRowLss));
});
export var TableExpansion = styled(TableBodyRow)(function (_a) {
    var theme = _a.theme;
    return "\n    border-top: " + theme.borders.regular + ";\n    cursor: default;\n\n    &:nth-child(2) {\n      box-shadow: " + theme.shadows.inset + ";\n    }\n  ";
});
export var TableCell = styled.td(function (_a) {
    var truncatesText = _a.truncatesText, _b = _a.lss, lss = _b === void 0 ? {} : _b;
    var truncatesTextLss = truncatesText
        ? {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 0
        }
        : {};
    return themeLss(__assign(__assign({ px: 'sm', py: 'lg', ':first-child': {
            pl: 'lg'
        }, ':last-child': {
            pr: 'lg'
        } }, truncatesTextLss), lss));
});
export function SelectAllToggle(_a) {
    var data = _a.data, onSelectAll = _a.onSelectAll, selectedRowKeys = _a.selectedRowKeys;
    var allRowsSelected = useMemo(function () {
        return selectedRowKeys && selectedRowKeys.size === data.length;
    }, [selectedRowKeys, data]);
    return (React.createElement(Checkbox, { "aria-label": allRowsSelected ? 'Deselect all' : 'Select all', checked: allRowsSelected, isIndeterminate: !allRowsSelected && selectedRowKeys && selectedRowKeys.size > 0, lss: { textScale: 'content' }, name: "", onChange: function () { return onSelectAll(!allRowsSelected); } }));
}
//# sourceMappingURL=DataTableComponents.js.map